import type { AxiosResponse } from 'axios';
import { api } from './index'

export interface TopActivitiesItem {
  donorName: string;
  donorId: string;
  creatorName: string;
  creatorId: string;
  seedAmount: number;
  thumbnailUrl: string;
  postId: string;
}

export async function findTopActivity(): Promise<TopActivitiesItem[] | null> {
  let res: AxiosResponse<{ data: TopActivitiesItem[] }>;

  try {
    res = await api.get('v2/feed/top-activity');
  } catch (err) {
    return null;
  }

  return res.data.data;
}
